import { useState } from "react";
import { motion } from "framer-motion";
import { Input } from "@/components/ui/input";
import { submitLead } from "@/lib/api";
import { HOME } from "@/constants/testIds";

const LeadCapture = () => {
  const [email, setEmail] = useState("");
  const [appName, setAppName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      setError("Enter a valid email");
      return;
    }
    setError("");
    try {
      await submitLead({ email, app_name: appName || undefined });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Try again.");
    }
  };

  return (
    <section className="relative py-24 sm:py-32 px-6 lg:px-12">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#7C93B8] mb-4">Stay In The Loop</p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight leading-tight mb-10">
          Get new viral hooks and ASO playbooks before your competitors do.
        </h2>

        {submitted ? (
          <motion.p
            data-testid={HOME.leadSuccessMsg}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="text-white font-semibold"
          >
            You're in. Watch your inbox.
          </motion.p>
        ) : (
          <form onSubmit={handleSubmit} noValidate className="glass-panel rounded-full p-2 flex flex-col sm:flex-row gap-2 max-w-xl mx-auto">
            <Input
              data-testid={HOME.leadEmailInput}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@yourapp.com"
              className="bg-transparent border-none text-white placeholder:text-white/30 h-12 flex-1 focus-visible:ring-0"
            />
            <button
              data-testid={HOME.leadSubmitBtn}
              type="submit"
              className="rounded-full bg-[#2563EB] text-white font-semibold px-6 py-3 text-sm hover:bg-[#3B82F6] transition-colors duration-300 whitespace-nowrap"
            >
              Notify Me
            </button>
          </form>
        )}
        {error && <p className="text-sm text-red-400 mt-3">{error}</p>}
      </div>
    </section>
  );
};

export default LeadCapture;
